<template>

	<div class="wrapper" :class="{'wrapper--overlay': $route.meta.showModal}">

		<div class="home" v-show="!showEpisode && showWebsite">
			<logo></logo>
			
			<div class="bg" :class="{'is-blurred': $route.meta.showModal}">

				<div class="skyline-bg pl">
					<div class="skyline-bg__cloud"></div>
				</div>
				<div class="skyline-right pl"></div>
				<div class="skyline-left pl"></div>

				<div class="clouds-bg pl"></div>
				<div class="cloud cloud--left-top pl"></div>			
				<div class="cloud cloud--left_bottom pl"></div>			
				<div class="cloud cloud--right_bottom pl"></div>
				<div class="cloud cloud--right-top pl"></div>


				<div id="building" class="building" ref="building">

					<window-video v-for="(video, index) in randomWindowVideos" :key="index" :data="video"></window-video>

					<png-sequence 
						:image="'sequence-boterham-min.png'" 
						:height="437" 
						:width="400" 
						:frames="39" 
						:left="722" 
						:top="332"
					></png-sequence>

					<png-sequence 
						:image="'sequence-smoke.png'" 
						:height="323" 
						:width="200" 
						:frames="50" 
						:left="1087" 
						:top="412"
					></png-sequence>

					<png-sequence 
						:image="'sequence-neon-min.png'" 
						:height="285" 
						:width="289" 
						:frames="43" 
						:left="785" 
						:top="5637"
					></png-sequence>


					<vlieg 
						:imageRight="'sprite-vlieg-right.png'"
						:imageLeft="'sprite-vlieg-left.png'"
						:height="60" 
						:width="60" 
						:frames="8"
						:audio="sound"
					></vlieg>

					<div class="building-image" ref="buildingImage">
						<img class="building-image__skeleton" :src="urlSkeleton" alt="" />
						<img class="building-image__top" :src="urlTop" alt="" />
						<img class="building-image__bottom" :src="urlBottom" alt="" />
					</div>

					<div class="bushes bushes--before"></div>
					<div class="bushes bushes--after"></div>

					<div class="light-shed glow-01"></div>
					<div class="light-lightbulb flicker"></div>
					<div class="light-blur light-blur--1 glow-01"></div>
					<div class="light-blur light-blur--2 glow-01"></div>
					<div class="light-blur light-blur--3 glow-01"></div>
					<div class="light-blur light-blur--4 glow-01"></div>
					<div class="light-blur light-blur--5 glow-01"></div>
					<div class="light-blur light-blur--6 glow-01"></div>
					<div class="light-blur light-blur--7 glow-01"></div>
					<div class="light-blur light-blur--8 glow-01"></div>

					<button @click="openEpisode($event)" class="codeslot" aria-label="Open de aflevering van vandaag"></button>
					<button v-if="!closed" @click="openEpisode($event)" class="door" aria-label="Open de aflevering via de deur"></button>

					<div id="trigger1" class="spacer s0"></div>
					<div id="trigger2" class="spacer s0" ref="trigger2"></div>				

				</div>

			</div>

			<router-link v-if="lastFiveEpisodes.length > 0" class="episodes-button" :class="{'episodes-button--hide': $route.meta.showModal}" to="/afleveringen">speel meer afleveringen</router-link>

			<router-link class="podcast-button" :class="{'podcast-button--hide': $route.meta.showModal}" to="/podcast">luister naar de podcast</router-link>

			<router-link class="info-link" :class="{'info-link--hide': $route.meta.showModal}" to="/info">informatie</router-link>

		</div>

		<router-view></router-view>

	</div>

</template>

<script>

import { mapState, mapGetters } from 'vuex'
import { TweenMax, TimelineMax } from 'gsap'
import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';  
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';  
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators'; 

import ScrollToPlugin from 'gsap/src/uncompressed/plugins/ScrollToPlugin'
import AudioSprite from './AudioSpriteWebsite';
import PngSequence from './PngSequence'
import Vlieg from './Vlieg'
import WindowVideo from './WindowVideo'
import Modernizr from 'modernizr';

import Logo from './../common/Logo'


export default {

	components: {
		PngSequence,
		Vlieg,
		Logo,
		WindowVideo
	},

	props: ['activateScrollandAudio', 'activateScrollBottom', 'closedBuilding'],

	watch: {

		showWebsite: function() {
			if (this.showWebsite && !this.initialLoad) {
				this.$nextTick(function() {
					window.scroll(0, document.body.scrollHeight)
				});
			}
			if(this.showWebsite && !this.isScrolled && this.initialLoad) {
				setTimeout(() => {
					this.isScrolled = true
					this.scroll();
				}, 500 );
			}
		},


		activateScrollBottom: function() {

			if( this.activateScrollBottom ) 
			{
				
				window.scroll(0, document.body.scrollHeight)
				
				this.$emit('changeScrollBottom');
			}

		},		


	},

	data() {

		return {

			isTouch: '',
			audioElement: null,
			urlSkeleton: require('../../assets/images/website/building-skeleton.png'),
			urlTop: require('../../assets/images/website/building-top.jpg'),
			urlBottom: require('../../assets/images/website/building-bottom.jpg'),
			widthRatio: 1,
			heightRatio: 1,
			isScrolled: false,

			boterhamSequence: 0,
			smokeSequence: 0,

			controller: '',
			sceneClouds: '',
			sceneCloudsBg: '',
			sceneBushes: '',
			sceneSkyline: '',

			windowVideos:
				[
					[
						{
							src: process.env.VIDEO_PATH+'website/bernie-danst.mp4',
							style: {
								width: '4.8vw',
								left: '41.7%',
								top: '35%'
							}
						},
						{
							src: process.env.VIDEO_PATH+'website/schoonmaakster.mp4',
							style: {
								width: '4.8vw',
								left: '56.5%',
								top: '19.5%'
							}
						},
						{
							src: process.env.VIDEO_PATH+'website/nico-slaapt.mp4',
							style: {
								width: '7.5vw',
								left: '44.4%',
								top: '25.5%'
							}
						},						
					],
					[
						{
							src: process.env.VIDEO_PATH+'website/bernie-belt.mp4',
							style: {
								width: '5vw',
								left: '70%',
								top: '35%'
							}
						},
						{
							src: process.env.VIDEO_PATH+'website/koe.mp4',
							style: {
								width: '5vw',
								left: '46%',
								top: '19.5%'
							}
						},
						{
							src: process.env.VIDEO_PATH+'website/nico-closeup.mp4',
							style: {
								width: '5.2vw',
								left: '35%',
								top: '66%'
							}
						},
					],
					[
						{
							src: process.env.VIDEO_PATH+'website/nico-leest.mp4',
							style: {
								width: '4.8vw',
								left: '56.5%',
								top: '19.5%'
							}
						},
						{
							src: process.env.VIDEO_PATH+'website/bernie-variaties.mp4',
							style: {
								width: '5.3vw',
								left: '57.7%',
								top: '80.7%'
							}
						},
						{
							src: process.env.VIDEO_PATH+'website/opperdepop.mp4',
							style: {
								width: '4.8vw',
								left: '41.7%',
								top: '35%'
							}
						},
						{
							src: process.env.VIDEO_PATH+'website/pi.mp4',
							style: {
								width: '5.3vw',
								top: '58.4%',
								left: '34.9%'
							}
						}
					],
					[
						{
							src: process.env.VIDEO_PATH+'website/peterallesweter.mp4',
							style: {
								width: '5vw',
								left: '32.4%',
								top: '35.06%'
							}
						},
						{
							src: process.env.VIDEO_PATH+'website/pop.mp4',
							style: {
								width: '5.3vw',
								top: '58.4%',
								left: '34.9%'
							}
						},
						{
							src: process.env.VIDEO_PATH+'website/schaap-nico.mp4',
							style: {
								width: '7.5vw',
								top: '25.5%',
								left: '34%'
							}
						},
					],
					[
						{
							src: process.env.VIDEO_PATH+'website/schaap.mp4',
							style: {
								width: '5.1vw',
								top: '49.5%',
								left: '57.6%'
							}
						},
						{
							src: process.env.VIDEO_PATH+'website/schoonmaakster-leest.mp4',
							style: {
								width: '5.3vw',
								top: '51%',
								left: '46.2%'
							}
						},
						{
							src: process.env.VIDEO_PATH+'website/spin.mp4',
							style: {
								width: '5vw',
								top: '43.55%',
								left: '35%'
							}
						},
					]
				],

			timeOuts: true,
			closed: this.closedBuilding,

			sound: new Howl({
				src: [process.env.VIDEO_PATH.replace('video', 'audio') + 'website-audiosprite.mp3'],
				sprite: AudioSprite
			})

		}

	},

	beforeMount() {
		this.isTouch = Modernizr.touchevents
	},

	mounted: function () {
		var width = this.$refs.building.offsetWidth;
		var height = this.$refs.building.clientHeight;
		if (!this.isTouch) {
			this.initScroll()
			window.addEventListener('resize', () => this.resize())
			this.resize()
		}
 	},

	computed: {
		...mapState([
			'showWebsite',
			'showEpisode',
			'initialLoad',
			'weekendEpisodes'
		]),
		...mapGetters([
			'getTodaysEpisode',
			'lastFiveEpisodes'
		]),
		randomWindowVideos () {
			return this.windowVideos[Math.floor(Math.random()*this.windowVideos.length)]
		}
	},

 	methods: {

		playAudio( item ) {

			if( this.timeOuts )
			{
				this.sound.play(item);
			}

		},

 		scroll() {
			TweenLite.to(window, 3, {scrollTo:{y: 'max', ease:Power1.easeInOut}, onComplete: () => {
				this.openEpisode()
			}});
 		},

		resize() {

			var width = window.innerWidth;
			var height = window.innerHeight;
			var ratio = (height / width).toFixed(2);

			var sceneCloudsDuration = 10000, sceneCloudsOffset = 0;
			var sceneCloudsBgDuration = 5000, sceneCloudsBgOffset = 500;
			var sceneBushesDuration = 750, sceneBushesOffset = 0;
			var sceneSkylineDuration = 10000, sceneSkylineOffset = 0;			



			if( ratio >= 1) { 

				sceneSkylineOffset = -1700;
				sceneSkylineDuration = 10000,
				sceneCloudsOffset = 1700;
				sceneBushesDuration = 700;
				sceneBushesOffset = -750;				

			}

			else if( ratio > 0.8 && ratio <= 1 ) { 

 				sceneCloudsOffset = -1000;
				sceneBushesOffset = -500;
 				sceneSkylineDuration = 9000;
 				sceneSkylineOffset = -800;

			}

			else if( ratio > 0.6 && ratio <= 0.8 ) { 

 				sceneCloudsOffset = -700;
				sceneBushesOffset = -200;
 				sceneSkylineDuration = 9000 
 				sceneSkylineOffset = -300;

			}

			else if( ratio < 0.45 ) {

				sceneSkylineOffset = 400;

			}			

			
			this.sceneSkyline.duration( sceneSkylineDuration );
			this.sceneSkyline.offset( sceneSkylineOffset );
			this.sceneClouds.offset( sceneCloudsOffset );
			this.sceneBushes.duration( sceneBushesDuration );
			this.sceneBushes.offset( sceneBushesOffset );

			// this.sceneClouds.duration( sceneCloudsDuration );
			// this.sceneCloudsBg.duration( sceneCloudsBgDuration );
			// this.sceneCloudsBg.offset( sceneCloudsBgOffset );

		},		


 		initScroll() {

 			this.controller = new ScrollMagic.Controller({ /* addIndicators: true */ });


 			// TWEENS ------------------------------------------------------------------------------------------------------------------------

			var tweenSkylineFront = new TimelineMax ()
				.add([

					TweenMax.fromTo(".skyline-right", 1, {top: "110vh"}, {top: "-30vh"}),
					TweenMax.fromTo(".skyline-left", 1, {top: "110vh"}, {top: "-30vh"}),

				]);

			var tweenSkyline = TweenMax.fromTo(".skyline-bg", 1, 
				{y: "40%"}, 
				{y: "-80%", ease: Linear.easeNone});

			var tweenSkylineCloud = TweenMax.fromTo(".skyline-bg__cloud", 1, 
				{y: "-9%", opacity: 0.15, x: "0%" }, 
				{y: "-20%", opacity: 0,  x: "-2%", ease: Linear.easeNone});


			var tweenCloudsBg =  TweenMax.fromTo(".wrapper .clouds-bg", 1, 
				{top: "0%", ease: Linear.easeNone}, 
				{top: "-80%", ease: Linear.easeNone});

 			var tweenCloudsLeft = new TimelineMax ()
 				.add([

 					TweenMax.fromTo(".wrapper .cloud--left-top", 1,
 						{top: "70%", opacity:0.15, x: "0%", ease: Linear.easeNone}, 
 						{top: "-20%", opacity:0.1, x: "-15%", ease: Linear.easeNone}),

					TweenMax.fromTo(".wrapper .cloud--left_bottom", 1, 
						{top: "100%", x:'0%', opacity:0.15, ease: Linear.easeNone },
						{top: "0%", x: '-5%', opacity:0.1, ease: Linear.easeNone })

 				]);

			var tweenCloudRightBottom = TweenMax.fromTo(".wrapper .cloud--right_bottom", 2, 
					{top: "100%", x:'0%', opacity:0.15, ease: Linear.easeNone},
					{top: "-90%", x: '-5%', opacity:0.1, ease: Linear.easeNone});

			var tweenCloudRightTop = TweenMax.fromTo(".wrapper .cloud--right-top", 2,
					{top: "90%", x:'0%', opacity:0.15, ease: Linear.easeNone}, 
					{top: "-90%", x: '-5%', opacity:0.1, ease: Linear.easeNone});


			// -------------------------------------------------------------------------------------------------------------------------------


			// SCENES ------------------------------------------------------------------------------------------------------------------------

 			this.sceneClouds = new ScrollMagic.Scene({

 				triggerElement: ".wrapper", 
 				duration: 10000, 
 				offset: 0

 			})
			.setTween([tweenCloudRightBottom, tweenCloudRightTop, tweenCloudsLeft])
			.addTo(this.controller);


 			this.sceneCloudsBg = new ScrollMagic.Scene({

 				triggerElement: ".wrapper", 
 				duration: 5000, 
 				offset: 500

 			})
			.setTween(tweenCloudsBg)
			.addTo(this.controller);


 			this.sceneBushes = new ScrollMagic.Scene({

				triggerElement: "#trigger2",
				duration: 750,
				offset: 0

			})
			.setTween(TweenMax.fromTo(".bushes--before", 1, {bottom: "-3%"}, {bottom: "-1%"}))
			.addTo(this.controller);


 			this.sceneSkyline = new ScrollMagic.Scene({

 				triggerElement: ".wrapper",
 				duration: 10000, 
 				offset: 0

			})
			.setTween( [tweenSkylineFront, tweenSkyline, tweenSkylineCloud] )
			.addTo(this.controller);


 			// this.sceneClouds.addIndicators({name: "clouds scene", colorEnd: "#FFFFFF", indent: 0 });
 			// this.sceneCloudLeftBottom.addIndicators({name: "clouds 3", colorEnd: "#FFFFFF", indent: 10 });
 			// this.sceneCloudsBg.addIndicators({name: "clouds 1 & 2", colorEnd: "#FFFFFF", indent: 10 });

			// this.sceneClouds.removeIndicators();
			// this.sceneBushes.removeIndicators();
			// this.sceneSkyline.removeIndicators();
			// this.sceneCloudLeftBottom.removeIndicators();
			// this.sceneCloudsBg.removeIndicators();

 		},

 		openEpisode(el) {

			if (el !== undefined) {
				if (tracker in window) {
					window.tracker.click({
					click_name: 'deuren',
					click_type: 'navigation',
					click_chapter_1: 'programmas',
					click_chapter_2: 'de-boterhamshow',
					click_chapter_3: 'interactive',
					});


				}	
			}

			this.timeOuts = false;
			this.sound.stop();
			if(this.getTodaysEpisode.length > 0) {
				const episodeNumber = this.getTodaysEpisode[0].episodes[0].name && this.getTodaysEpisode[0].episodes[0].name.split('-')[1];
				if (episodeNumber) {
					this.$router.push({ name: 'aflevering', params: { id: episodeNumber }})
				} else {
					console.warn('No valid episode id found for today\'s episode.');
				}
			} else {
				const validWeekendEpisodes = this.weekendEpisodes.filter(ep => ep.name && ep.name.includes('-'));
				if (validWeekendEpisodes.length > 0) {
					const episode = validWeekendEpisodes[Math.floor(Math.random()*validWeekendEpisodes.length)].name.split('-')[1];
					if (episode) {
						this.$router.push({ name: 'aflevering', params: { id: episode }})
					} else {
						console.warn('No valid episode id found in weekendEpisodes.');
					}
				} else {
					console.warn('No valid weekendEpisodes available to open.');
				}
				// this.sound.play('boterhamshow-is-dicht')
			}

 		}

	},
}

</script>

<style lang="scss">

// ------------------------------------------------------------------------------------------------------ START - COMMON

.wrapper {

	&:after {	
		content: '';
		opacity: 0;
		transition: opacity 2s ease;
	}

	&--overlay {
		&:after {
			content: '';
			width: 100%;
			height: 100%;
			background: #4d5259;
			background: -moz-linear-gradient(45deg, #4d5259 0%, #292f36 100%);
			background: -webkit-linear-gradient(45deg, #4d5259 0%,#292f36 100%);
			background: linear-gradient(45deg, #4d5259 0%,#292f36 100%);
			filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4d5259', endColorstr='#292f36',GradientType=1 );
			top: 0;
			left: 0;
			position: fixed;
			z-index: 3001;
			opacity: 0.7;
		}
	}

}

html {

	overflow-y: scroll;
	overflow-x: hidden;	

}

.bg {
	background: linear-gradient(45deg, #5f6363 0%,#313641 100%);
	transition: filter .3s;
	//&.is-blurred {
		// filter: blur(8px);
	//}
}


// ------------------------------------------------------------------------------------------------------ END - COMMON

// ------------------------------------------------------------------------------------------------------ START - BUILDING

#building {

	padding: 0;
	margin: 0;
	width: 100%;
	height: 100%;
	position: relative;
	transform-origin: top;
	overflow: hidden;

}

.building-image {

	transform-origin: bottom;
	position: relative;
	z-index: 3;

}

	.building-image__skeleton {
		
		position: relative;
		top: 0;
		left: 0;
		width: 100%;
		display: block;
		z-index: 2;

	}

	.building-image__top {

		position: absolute;
	    left: 28.07%;
	    top: 12.28%;
	    width: 41.20%;
		z-index: 2;

	}

	.building-image__bottom {
	    
	    position: absolute;
		top: 30.47%;
	    width: 59.571%;
	    left: 19.08%;
	    z-index: 2;

	}

.codeslot {

	position: absolute;
	border: none;
	padding: 0;
	background: url('../../assets/images/website/codeslot.png');
	background-repeat: no-repeat;
	background-size: 100%;
	left: 40.3%;
	bottom: 3.6%;
	width: 1.8vw;
	height: 1.5vw;
	z-index: 5;
	cursor: pointer;
	display: block;

}

.door {

	position: absolute;
	border: none;
	padding: 0;
	background: transparent;
	left: 43%;
	bottom: 1.6%;
	width: 12vw;
	height: 15vw;
	z-index: 5;
	cursor: pointer;
	display: block;

}

// ------------------------------------------------------------------------------------------------------ END - BUILDING

// ------------------------------------------------------------------------------------------------------ START - TRIGGERS

#trigger1 { 

	position: absolute;
	left: 100px;
	top: 15%;
	width: 100px;
	height: 100px;

}

#trigger2 { 

	position: absolute;
	left: 100px;
	bottom: 12%;
	width: 100px;
	height: 100px;

}

// ------------------------------------------------------------------------------------------------------ END - TRIGGERS

// ------------------------------------------------------------------------------------------------------ START - CLOUDS & SKYLINE

.clouds-bg {

	background: url('../../assets/images/website/cloud-bg.png');
	background-repeat: no-repeat;
	background-size: 100%;
	width: 100vw;
	height: 45vw;
	position: fixed;
	top: 0%;
	left: 0%;
	z-index: 0;

}

.cloud {

	position: fixed;
	z-index: 0;
	opacity: 0.1;

	&--left-top {

		background: url('../../assets/images/website/cloud-left-top-min.png');
		background-repeat: no-repeat;
		background-size: 100%;		
		width: 30vw;
		height: 24vw;
		top: 20%;
		left: -12%;
		z-index: 1;

	}

	&--left_bottom {

		background: url('../../assets/images/website/cloud-left_bottom-min.png');
		background-repeat: no-repeat;
		background-size: 100%;		
		width: 10vw;
		height: 10vw;
		top: 0%;
		left: 23%;

	}	

	&--right_bottom {

		background: url('../../assets/images/website/cloud-right_bottom-min.png');
		background-repeat: no-repeat;
		background-size: 100%;
	    width: 13vw;
	    height: 10vw;
	    top: 0%;
	    left: 81.5%;

	}

	&--right-top {

		background: url('../../assets/images/website/cloud-right-top-min.png');
		background-repeat: no-repeat;
		background-size: 100%;		
		width: 12vw;
		height: 20vw;
		top: 70%;
		left: 95%;

	}

}


.skyline-bg {

	background: url('../../assets/images/website/skyline-bg.png');
	background-repeat: repeat-x;
	background-position: top center;
	background-size: cover;	
	position: fixed;
	width: 100%;
    height: 100%;
	left: 0;
	bottom: 0;
	z-index: 0;

	&::after {

		content: '';
		position: absolute; 
		width: 100%;
		height: 100%;
		background: #1e1e19;
		bottom: -100%;
		left: 0;

	}
 
	&__cloud {

		width: 100vw;
    	height: 100vh;
    	position: absolute;
		left: 0;
		top: 0;

    	background: url('../../assets/images/website/skyline-bg-cloud.png');    
		background-size: cover;
		background-repeat: no-repeat;
		background-position: top center;
		z-index: 1;
		opacity: 0.1;

	}	

}

.skyline-right {

	background: url('../../assets/images/website/skyline-right.png');
	background-repeat: no-repeat;
	width: 42vw;
	height: 150vh;
	position: fixed;
	right: -10vw;
	background-size: 100%;
	z-index: 1;

}

.skyline-left {

	background: url('../../assets/images/website/skyline-left.png');
	background-repeat: no-repeat;
	width: 23vw;
	height: 150vh;
	position: fixed;
	left: 0;
	background-size: 100%;
	z-index: 2;

}

// ------------------------------------------------------------------------------------------------------ END - CLOUDS & SKYLINE

// ------------------------------------------------------------------------------------------------------ START - BUSHES

.bushes {

	background: url('../../assets/images/website/bushes-before-min.png');
	background-repeat: no-repeat;
	background-size: 100%;

	width: 110vw;
    height: 17vw;
	position: absolute;


	&--before {

		bottom: -2%;
		left: -5vw;
		z-index: 5

	}

	&--after {

		background: url('../../assets/images/website/bushes-after-min.png');
		background-repeat: no-repeat;
		background-size: 100%;

		bottom: 1%;
		left: -7vw;
		z-index: 2;

	}

}

// ------------------------------------------------------------------------------------------------------ END - BUSHES

// ------------------------------------------------------------------------------------------------------ START - LIGHTS

.light-shed {

	width: 10%;
    height: 3%;
    display: block;
    position: absolute;
	background: url('../../assets/images/website/light-shed.png');
    background-size: 100%;
    background-repeat: no-repeat;
    top: 40.23%;
    left: 32%;
    z-index: 10;


}

.light-lightbulb {

    width: 5.6%;
    height: 3%;
    display: block;
    position: absolute;
	background: url('../../assets/images/website/light-lightbulb.jpg');
    background-size: 100%;
    background-repeat: no-repeat;
    top: 91.73%;
    left: 64.2%;
    z-index: 10;


}


.light-blur {

    width: 12%;
    height: 5%;
    display: block;
    position: absolute;
	background: url('../../assets/images/website/light-blur.png');
    background-size: 100%;
    background-repeat: no-repeat;
    z-index: 10;

	&--1 { top: 43.00%; left: 66.7%; opacity: 0.8; }
	&--2 { top: 48.40%; left: 31.6%; opacity: 0.8; }	
	&--3 { top: 51.40%; left: 42.7%; opacity: 0.8; }	
	&--4 { top: 57.10%; left: 67.0%; opacity: 0.8; }	
	&--5 { top: 61.50%; left: 18.6%; opacity: 0.8; }	
	&--6 { top: 69.40%; left: 54.3%; opacity: 0.8; }	
	&--7 { top: 67.80%; left: 54.6%; opacity: 0.8; }
	&--8 { top: 80.05%; left: 31.6%; opacity: 0.8; }	

}


.glow-01 { animation: glow-layer-01 5s ease-in-out infinite; opacity: 0; }
.glow-02 { animation: glow-layer-02 3s ease-in-out infinite; opacity: 0; }
.glow-03 { animation: glow-layer-03 10s ease-in-out infinite; opacity: 0; }



@keyframes glow-layer-01 {

	0%, 25% { opacity: 0.8; }
	50%, 75% { opacity: 0.4 }
	100% { opacity: 0.8 }

}

@keyframes glow-layer-02 {

	0%, 33% { opacity: 0; }
	34%, 76% { opacity: 1; }
	100% { opacity: 0; }

}

@keyframes glow-layer-03 {

	0%, 77% { opacity: 0; }
	78%, 100% { opacity: 1; }

}



.flicker {

    animation-name: flicker;
    animation-duration: 4s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

}

@keyframes flicker {

	0%, 9.999%, 22%, 62.999%, 64%, 64.999%, 70%, 100% { opacity: 1; }
	20%, 21.999%, 63%, 63.999%, 65%, 69.999% { opacity: 0.4; }

}

// ------------------------------------------------------------------------------------------------------ END - LIGHTS

// ------------------------------------------------------------------------------------------------------ START - TOUCHEVENTS


.touchevents {

	html, body {

		-webkit-overflow-scrolling: touch;

	}

	.skyline-bg {

		background-position: bottom center;

	}	

	.cloud,
	.skyline-bg__cloud { 

		display: none;

	}

	.clouds-bg {

		display: none;

	}

	.skyline-right {

		width: 42vw;
		height: 80vw;
		bottom: -5vw;


		@media (orientation: landscape) {

		 	width: 74vh;
			height: 69vh;
			right: -15vw;

		}

	}

	.skyline-left {

		bottom: -15vh;
		width: 23vw;
		height: 100vw;

		@media (orientation: landscape) {

		  	width: 33vh;
		  	height: 100vh;
		  	bottom: -55vh;

		}

	}

}

.podcast-button {
	position: fixed;
	z-index: 1000;
	bottom: 24px;
	left: 88px;
	color: black;
	font-family: bariol-bold;
	font-weight: normal;
	background: white;
	font-size: 18px;
	text-decoration: underline;
	border-radius: 20px;
	padding: 6px 16px 10px 16px;
	transition: all .25s ease;

	&:before {
		content: '';
		width: 54px;
		height: 54px;
		position: absolute;
		left: -68px;
		top: -12px;
		background: url('../../assets/images/website/opperpodcast.png');
		background-size: cover;
	}

	&:after {
		content: '';
		position: absolute;
		left: -4px;
		top: 12px;
		width: 0;
		height: 0;
		border-top: 10px solid transparent;
		border-bottom: 10px solid transparent;
		border-right: 10px solid white;
	}

	&:hover {
		text-decoration: none;
	}

	&--hide {
		bottom: 10px;
		opacity: 0;
	}
}

.episodes-button {
	position: fixed;
	z-index: 1000;
	bottom: 24px;
	right: 88px;
	color: black;
	font-family: bariol-bold;
	font-weight: normal;
	background: white;
	font-size: 18px;
	text-decoration: underline;
	border-radius: 20px;
	padding: 6px 16px 10px 16px;
	transition: all .25s ease;

	&:before {
		content: '';
		width: 54px;
		height: 54px;
		position: absolute; 
		right:-68px;
		top: -12px;
		background: url('../../assets/images/website/berny.png');
		background-size: cover;
	}

	&:after {
		content: '';
		position: absolute; 
		right:-4px;
		top: 12px;
		width: 0; 
		height: 0; 
		border-top: 10px solid transparent;
		border-bottom: 10px solid transparent;
		border-left: 10px solid white;
	}	

	&:hover {
		text-decoration: none;
	}

	&--hide {
		bottom: 10px;
		opacity: 0;
	}
}

.info-link {
	position: fixed;
	z-index: 1000;
	top: 16px;
	right: 20px;
	color: #ffffff;
	font-family: bariol-regular, sans-serif;
	font-size: 13px;
	text-decoration: none;
	background: #292f36;
	border-radius: 20px;
	padding: 5px 14px 7px 14px;
	transition: all .25s ease;

	&:hover {
		background: #3d4550;
	}

	&--hide {
		opacity: 0;
		pointer-events: none;
	}
}


// ------------------------------------------------------------------------------------------------------ END - TOUCHEVENTS

</style>


// WEBPACK FOOTER //
// Home.vue?0f58cd2d